export const emailGroupNameLength = 30;

export default {};
